// Flex column component with centered elements
import styled from 'styled-components'

interface CenterProps {
  // flex direction row?
  row?: boolean
  // center along cross axis too?
  cross?: boolean
}
const Center = styled.div<CenterProps>`
  display: flex;
  flex-direction: column;
  ${props => props.row && 'flex-direction: row;'}
  justify-content: center;
  ${props => props.cross && 'align-items: center;'}
`

export default Center
